import { useQuery } from '@tanstack/react-query'
import { IbgeController } from 'src/controllers/ibge.controller'
import { IbgeCityDto } from 'src/dto/ibge.dto'

const ibgeController = new IbgeController()

export function useGetCitiesByUf(uf: string) {
  return useQuery<IbgeCityDto[], Error>({
    queryKey: ['getCitiesByUf', uf],
    queryFn: () => ibgeController.getCitiesByUf(uf),
    enabled: !!uf && uf.length === 2
  })
}
